import React, { useRef, useEffect } from "react";
import { Drawer, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ActionBar from "../../../components/action-bar";
import useDispatchWithResult from "../../../hooks/useDispatchWithResult";
import { fetchSignatariosEmpresa } from "../../../store/assinatura";
import { createHashId } from "@util/signerId";
import { fetchUnidades } from "@/store/empresa";
import CadastrosBaseTable from "@/components/table-cadastros";
import UnidadesBaseTable from "@/components/table-unidades";

const RegistroDrawer = ({
  isOpen,
  onClose,
  empresaId,
  onAddSigner,
  signatariosPending,
  activeTab,
  setActiveTab
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatchWithResult();

  const actionBarRef1 = useRef();
  const actionBarRef2 = useRef();

  const { signatariosEmpresas, loading: loadingSignatarios } = useSelector(
    (state) => state.assinaturas
  );
  const { unidades, loading: loadingUnidades } = useSelector(
    (state) => state.empresa
  );

  const handleTabChange = (key) => {
    setActiveTab(key);

    setTimeout(() => {
      const ref = key === "1" ? actionBarRef1 : actionBarRef2;
      ref.current?.focus();
    }, 50);

    if (key === "1") {
      dispatch(fetchUnidades({ empresaId }));
    } else {
      dispatch(fetchSignatariosEmpresa({ empresaId }));
    }
  };

  const handleDrawerOpen = () => {
    setTimeout(() => {
      const ref = activeTab === "1" ? actionBarRef1 : actionBarRef2;
      ref.current?.focus();
    }, 300);
  };

  const empresasTitle = () => (
    <ActionBar
      ref={actionBarRef2}
      onSearch={(value) =>
        dispatch(fetchSignatariosEmpresa({ empresaId, search: value }))
      }
      searchLoading={loadingSignatarios}
      searchFormatter="cpf"
    />
  );

  const empresasData = signatariosEmpresas.map((s) => ({
    id: createHashId(s),
    nome: s.nome.trim(),
    cpf: s.documento,
    email: s.email ?? "",
    registered: false,
    tipo: s.tipo,
  }));

  const pendingIds = signatariosPending.map((s) => s.id);

  const unidadesTitle = () => (
    <ActionBar
      ref={actionBarRef1}
      onSearch={(value) =>
        dispatch(fetchUnidades({ empresaId, search: value }))
      }
      searchLoading={loadingUnidades}
    />
  );

  const unidadesData = (unidades || []).map((u) => ({
    id: u.id,
    apelido: u.apelido,
    endereco: u.endereco,
    cidade: u.cidade,
    estado: u.estado,
    cep: u.cep,
    cnpj: u.cnpj,
  }));

  return (
    <Drawer
      title={t("Selecione a linha da informação abaixo:")}
      width="65%"
      onClose={onClose}
      open={isOpen}
      afterOpenChange={(open) => open && handleDrawerOpen()}
    >
      <Tabs
  activeKey={activeTab}
  onChange={(key) => {
    if (key === activeTab) handleTabChange(key);
  }}
  items={[
    {
      key: "1",
      label: (
        <span
          style={{
            pointerEvents: activeTab !== "1" ? "none" : "auto",
            opacity: activeTab !== "1" ? 0.5 : 1,
            cursor: activeTab !== "1" ? "not-allowed" : "pointer",
          }}
        >
          {t("Unidades")}
        </span>
      ),
      children: (
        <UnidadesBaseTable
          dataSource={unidadesData}
          loading={loadingUnidades}
          onClick={onAddSigner}
          title={unidadesTitle}
        />
      ),
    },
    {
      key: "2",
      label: (
        <span
          style={{
            pointerEvents: activeTab !== "2" ? "none" : "auto",
            opacity: activeTab !== "2" ? 0.5 : 1,
            cursor: activeTab !== "2" ? "not-allowed" : "pointer",
          }}
        >
          {t("Pessoas")}
        </span>
      ),
      children: (
        <CadastrosBaseTable
          dataSource={empresasData}
          loading={loadingSignatarios}
          onClick={onAddSigner}
          itemsList={pendingIds}
          title={empresasTitle}
        />
      ),
    },
  ]}
/>

    </Drawer>
  );
};

export default RegistroDrawer;
